import React, { useEffect, useState } from 'react';
import supabase from '../../../../supabaseClient';

function CalendarFilter({ filterCategory, setFilterCategory, filterEmployee, setFilterEmployee, categoryVersion, idConfig }) {
  const [categories, setCategories] = useState([]);
  const [managers, setManagers] = useState([]);

  useEffect(() => {
    if (!idConfig) return;
    supabase.from('calendar_categories').select('id, name').eq('id_configuration', idConfig).then(({ data, error }) => {
      if (error) { console.error('Błąd pobierania kategorii:', error); return; }
      setCategories(data || []);
    });
    supabase.from('profiles').select('id, full_name').eq('profile_type', 'manager').eq('id_configuration', idConfig).then(({ data, error }) => {
      if (error) { console.error('Błąd pobierania managerów:', error); return; }
      setManagers(data || []);
    });
  }, [idConfig, categoryVersion]);

  return (
    <>
      <select value={filterCategory} onChange={(e) => setFilterCategory(e.target.value)} style={selectStyle}>
        <option value="ALL">Wszystkie kategorie</option>
        {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
      </select>
      <select value={filterEmployee} onChange={(e) => setFilterEmployee(e.target.value)} style={selectStyle}>
        <option value="ALL">Wszyscy managerowie</option>
        {managers.map((m) => <option key={m.id} value={m.id}>{m.full_name}</option>)}
      </select>
    </>
  );
}

export default CalendarFilter;

const selectStyle = { border: '1px solid #e3d9d9', borderRadius: 8, padding: '7px 10px', fontSize: 12, color: '#2C1419', background: '#fff' };